"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderOrigination = void 0;
var PropTypes = require("prop-types");
var React = require("react");
var Icon_1 = require("../Icon");
var HeaderOriginationCloseButton_1 = require("./HeaderOriginationCloseButton");
var HeaderOrigination = function (props) {
    var bgSecondary = props.bgSecondary, _a = props.buttonAttributes, buttonAttributes = _a === void 0 ? {} : _a, children = props.children, _b = props.className, className = _b === void 0 ? '' : _b, closeText = props.closeText, hideClose = props.hideClose, href = props.href, onClick = props.onClick, fluid = props.fluid, logo = props.logo, logoHref = props.logoHref, attributes = __rest(props, ["bgSecondary", "buttonAttributes", "children", "className", "closeText", "hideClose", "href", "onClick", "fluid", "logo", "logoHref"]) // tslint:disable-line
    ;
    if (href === null && onClick === null) {
        props.hideClose = true;
    }
    else if (href) {
        buttonAttributes.href = href;
    }
    else if (onClick) {
        buttonAttributes.onClick = onClick;
    }
    var logoBlock = logo || (React.createElement(Icon_1.Icon, { screenreader: "Commonwealth Bank logo", symbol: "logoCBASymbol40", href: logoHref, type: "css" }));
    var classsNames = (className + " headerorigination " + (bgSecondary ? 'bg-lightsecondary' : 'bg-light')).trim();
    return (React.createElement("div", __assign({ className: classsNames }, attributes),
        React.createElement("div", { className: fluid ? 'container-fluid' : 'container' },
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-12" },
                    React.createElement("header", { role: "banner" },
                        React.createElement("div", { className: "headerorigination-logo" },
                            logoBlock,
                            children &&
                                children),
                        !props.hideClose &&
                            React.createElement(HeaderOriginationCloseButton_1.HeaderOriginationCloseButton, __assign({ closeText: closeText }, buttonAttributes))))))));
};
exports.HeaderOrigination = HeaderOrigination;
exports.HeaderOrigination.defaultProps = {
    fluid: true,
    hideClose: false,
};
exports.HeaderOrigination.propTypes = {
    buttonAttributes: PropTypes.object,
    children: PropTypes.any,
    closeText: PropTypes.string,
    fluid: PropTypes.bool,
    href: PropTypes.string,
    logo: PropTypes.element,
    logoHref: PropTypes.string,
    onClick: PropTypes.func,
    typecheck: function (props) {
        if (props.href && props.onClick) {
            return new Error('The HeaderOrigination should not contain both a "href" and an "onClick" prop.');
        }
        if (!props.href && !props.onClick) {
            return new Error('The HeaderOrigination should contain "href" or "onClick" prop.');
        }
        return;
    },
};
